module.exports = __webpack_public_path__ + "img/sixpackcarrier59.adcfc75a.jpg";